import TaskCard from './TaskCard'

function TaskList({ tasks, expandTaskId, onClearExpandTask, onToggleSubtask, onDeleteTask, onUpdateTask, onUpdateSubtask, onAddSubtask, onDeleteSubtask, onReorderSubtasks, onReplaceSubtasks, onStartFocus }) {
  if (tasks.length === 0) {
    return (
      <div className="task-list-empty">
        <p className="placeholder-text">
          No tasks yet. Use "Break It Down" above to add your first assignment!
        </p>
      </div>
    )
  }

  return (
    <div className="task-list-container">
      {tasks.map((task, index) => (
        <div key={task.id} className="stagger-item" style={{ animationDelay: `${Math.min(index, 8) * 60}ms` }}>
        <TaskCard
          task={task}
          autoExpand={expandTaskId === task.id}
          onClearExpandTask={onClearExpandTask}
          onToggleSubtask={onToggleSubtask}
          onDeleteTask={onDeleteTask}
          onUpdateTask={onUpdateTask}
          onUpdateSubtask={onUpdateSubtask}
          onAddSubtask={onAddSubtask}
          onDeleteSubtask={onDeleteSubtask}
          onReorderSubtasks={onReorderSubtasks}
          onReplaceSubtasks={onReplaceSubtasks}
          onStartFocus={onStartFocus}
        />
        </div>
      ))}
    </div>
  )
}

export default TaskList
